export const appVersion = '1.47.0';
